import { render, staticRenderFns } from "./FrameFooter.vue?vue&type=template&id=b80cef5a&scoped=true&"
import script from "./FrameFooter.vue?vue&type=script&lang=js&"
export * from "./FrameFooter.vue?vue&type=script&lang=js&"
import style0 from "./FrameFooter.vue?vue&type=style&index=0&lang=css&"
import style1 from "./FrameFooter.vue?vue&type=style&index=1&id=b80cef5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b80cef5a",
  null
  
)

export default component.exports